import React, { useState } from "react";
import Swal from "sweetalert2";
import { FaFileExcel, FaFilePdf } from "react-icons/fa";

export const ReportListHeading = ({ title }) => (
    <header className="report-list-heading">
        <h1>{title}</h1>
    </header>
);  

export const ReportListLoading = ({ message = "Loading report data..." }) => (
    <div className="report-list-loading" role="status" aria-live="polite">
        <span className="spinner-border report-list-loading__spinner" aria-hidden="true" />
        <div className="report-list-loading__content">
            <strong>{message}</strong>
            <span>Please wait while we prepare the latest records.</span>
            <span className="report-list-loading__skeleton" aria-hidden="true" />
        </div>
    </div>
);

export const ReportExportActions = ({ onPrint, onDownload, disabled = false }) => {
    const [exporting, setExporting] = useState(null);

    const runExport = async (type, action) => {
        if (exporting || disabled) return;

        if (type === "excel") setExporting(type);
        try {
            await action();
        } catch (error) {
            console.error(`Failed to ${type === "pdf" ? "generate PDF" : "download Excel report"}`, error);
            await Swal.fire(
                "Error",
                type === "pdf" ? "Failed to generate the PDF report." : "Failed to download the Excel report.",
                "error"
            );
        } finally {
            setExporting(null);
        }
    };

    return (
        <>
            <div className="report-list-actions">
                <button
                    className="btn btn-danger"
                    title="Download PDF"
                    aria-label="Download PDF"
                    disabled={disabled || Boolean(exporting)}
                    onClick={() => runExport("pdf", onPrint)}
                >
                    {exporting === "pdf" ? <span className="spinner-border spinner-border-sm" aria-hidden="true" /> : <FaFilePdf size={17} />}
                </button>
                <button
                    className="btn btn-success"
                    title="Download Excel"
                    aria-label="Download Excel"
                    disabled={disabled || Boolean(exporting)}
                    onClick={() => runExport("excel", onDownload)}
                >
                    {exporting === "excel" ? <span className="spinner-border spinner-border-sm" aria-hidden="true" /> : <FaFileExcel size={17} />}
                </button>
            </div>
            {exporting === "excel" && (
                <div className="report-export-backdrop" role="status" aria-live="polite">
                    <div className="report-export-progress">
                        <span className="spinner-border report-export-progress__spinner" aria-hidden="true" />
                        <strong>Preparing Excel download...</strong>
                        <span>Your report is being generated. Please wait.</span>
                    </div>
                </div>
            )}
        </>
    );
};
